import { useState } from 'react';
import type { DiemDanhDauGio } from '@/services/DiemDanhDauGio';
import { getDiemDanhHocSinh } from '@/services/DiemDanhDauGio/diemdanhdaugio';
import { getAttendanceSaturdayStudent } from '@/services/DiemDanhThuBay/diemdanhthubay';
export default () => {
    const [danhSach, setDanhSach] = useState<DiemDanhDauGio.Record[]>([]);
    const [record, setRecord] = useState<DiemDanhDauGio.Record>();
    const [loading, setLoading] = useState<boolean>(true);
    const [total, setTotal] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [cond, setCondition] = useState<any>({});
    const [filterInfo, setFilterInfo] = useState<any>({});
  
    const getDiemDanhModel = async (conId?: string ,donViId?: string, thang?: number, nam?: number) => {
      setLoading(true);
      const response = await getDiemDanhHocSinh({ page, limit, cond,conId, donViId, thang, nam });
      setDanhSach((response?.data?.data?.result ?? []).reverse());
      setTotal(response?.data?.data?.total);
      setLoading(false);
    };

    const getAttendanceAllModel = async (conId?: string ,donViId?: string, thang?: number, nam?: number) => {
      setLoading(true);
      let listData:any = []
      const response = await getDiemDanhHocSinh({cond, conId, donViId, thang, nam });
      const responseSaturday = await getAttendanceSaturdayStudent({ cond, conId, donViId, thang, nam });
      listData = [...response?.data?.data?.result, ...responseSaturday?.data?.data?.result]
      listData.sort((a: any, b: any) => {
        const ngayA = a?.ngay;
        const ngayB = b?.ngay;
      
        if (ngayA < ngayB) {
          return 1;
        } else if (ngayA > ngayB) {
          return -1;
        } else {
          return 0;
        }
      });
      setDanhSach((listData ?? []).reverse());
      setTotal(response?.data?.data?.total + responseSaturday?.data?.data?.total);
      setLoading(false);
    };
    return {
        danhSach,
        loading,
        setLoading,
        getDiemDanhModel,
        total,
        setTotal,
        page,
        setPage,
        limit,
        setLimit,
        cond,
        setCondition,
        filterInfo,
        setFilterInfo,
        setRecord,
        record,
        getAttendanceAllModel
      };
    };  